import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import {
  GET_ALL_ACTIVE_THERAPIST_KEY,
  GET_ALL_ADMIN_THERAPIST_KEY,
  GET_THERAPIST_KEY,
} from '_api/queries/therapist';
import { Therapist, UserPayload } from '_api/types';

export const CREATE_THERAPIST_KEY = 'create-therapist';

export const useCreateTherapist = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Therapist, UserPayload>(
    () => '/therapist/create',
    'post',
    {},
    {
      mutationKey: [CREATE_THERAPIST_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ACTIVE_THERAPIST_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ADMIN_THERAPIST_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_THERAPIST_KEY] });
      },
    },
    (body: UserPayload) => JSON.stringify(body),
  );
};
